import React from 'react';
import $ from 'jquery';
import ol from 'openlayers';

export default class Searcher extends React.Component {
	constructor(props) {
		super(props);
		this.lpmodel_misc = window.datastore.lps_misc.get(this.props.id);
		this.state = { searchtext: '', errorSearch: false}
		this.handleSearchChange = this.handleSearchChange.bind(this);
	    this.searchButtonClick = this.searchButtonClick.bind(this);
	}
	
	handleSearchChange(event) {
	    this.setState({searchtext: event.target.value, errorSearch: false});
	  }
	
	searchButtonClick (e) {
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);
		//e.preventDefault();
		var comp = this;
		var lpm = this.lpmodel_misc;
		$.ajax({
    	    url: "geocode",
    	    data: { 
    	        "qstr": this.state.searchtext
    	    },
    	    type: "GET",
    	    beforeSend: function () {
    	    	$("body").css("cursor", "progress");
    	    },
    	    success: function(response) {
    	    	$("body").css("cursor", "default");
    	    	var format = new ol.format.WKT();
    	    	var tempfeature = format.readFeature(response.geo);
    	    	var lonlatxy = tempfeature.getGeometry().transform('EPSG:3857', 'EPSG:4326').getCoordinates();
    	    	lonlatxy = {'lon': lonlatxy[0], 'lat': lonlatxy[1]}
    	    		lpm.set({lastSearchXY: lonlatxy});
        	    	lpm.trigger(comp.props.bbeventname);
        	    	comp.setState({
        	    		errorSearch: false
        	  	    });
    	    	
    	    },
    	    error: function() {
    	    	comp.setState({
    	    		errorSearch: true
    	  	    });
    	    },
    	    complete: function(xhr) {
    	    	$("body").css("cursor", "default");
    	    }
    	});
	}
	
	render() {
	    return (
	    		<form onSubmit={this.searchButtonClick}>
	    		  <div className={this.state.errorSearch === true ?  "form-group has-error" : "form-group"}>
	    		  <input type="text" className="form-control" value={this.state.searchtext} onChange={this.handleSearchChange} placeholder="z.B.: Salzburg Schwarzstraße"></input>
	    		  </div>
	    		  <button type="button" className="btn btn-success" onClick={this.searchButtonClick}>Suchen</button>
	    		</form>
	    )
	}
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/searcher.js